import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import {
  addDisclaimersError,
  addDisclaimersSuccess,
  getDisclaimersError,
  getDisclaimersSuccess,
  updateDisclaimersError,
  updateDisclaimersSuccess,
} from './actions'
import {
  DISCLAIMERS_ADD_ASYNC,
  DISCLAIMERS_REQUEST_ASYNC,
  DISCLAIMERS_UPDATE_ASYNC,
} from './constants'

const getDisclaimersEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DISCLAIMERS_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings.getDisclaimers().pipe(
        map((response) => getDisclaimersSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getDisclaimersError, error)))
      )
    )
  )

const addDisclaimersEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DISCLAIMERS_ADD_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .addDisclaimer({
          type: action.payload.disclaimer.type,
          text: action.payload.disclaimer.text,
        })
        .pipe(
          map(({ response }) =>
            addDisclaimersSuccess({
              id: response.id,
              tempId: action.payload.disclaimer.id,
            })
          ),
          catchError((error) => of(epicsErrorHandler(addDisclaimersError, error)))
        )
    )
  )

const updateDisclaimersEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DISCLAIMERS_UPDATE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .updateDisclaimer({
          id: action.payload.disclaimer.id,
          text: action.payload.disclaimer.text,
        })
        .pipe(
          map(() =>
            updateDisclaimersSuccess({
              id: action.payload.disclaimer.id,
            })
          ),
          catchError((error) => of(epicsErrorHandler(updateDisclaimersError, error)))
        )
    )
  )

export default combineEpics(getDisclaimersEpic, addDisclaimersEpic, updateDisclaimersEpic)
